/** Built-in value references. */
var Symbol = global.Symbol;

module.exports = Symbol;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_Symbol.js
 ** module id = 267
 ** module chunks = 0
 **/